import "core-js/modules/es6.regexp.search.js";
import IconTextLink from '~/components/molecules/Header/IconTextLink.vue';
var NavItemTree = () => import('./NavItemTree.vue');
var SearchItem = () => import('~/components/specific/TheHeader/Menu/SecondaryNav/Items/SearchItem.vue');
export default {
  name: 'LayerMobile',
  components: {
    IconTextLink,
    NavItemTree,
    SearchItem
  },
  props: {
    navigation: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    helpUrl: {
      type: String,
      default: ''
    },
    storeLocUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    flattened() {
      return this.navigation.reduce((acc, item) => acc.concat(item.flatable ? item.items : item), []);
    }
  },
  methods: {
    close() {
      this.$refs.tree.close();
      this.$refs.search.resetForm();
    }
  }
};